


































import { Component, Vue } from "vue-property-decorator";
import { dispatchLoadEntries } from "@/store/uniabc/actions";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { api } from "@/api";
import { readLastLoad } from "@/store/uniabc/getters";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";
import { readHasUnsavedChanges } from "@/store/appState/getters";
import SetBranch from "@/components/settings/SetBranch.vue";

@Component({
  components: { SetBranch }
})
export default class LoadEntries extends Vue {
  private projectName = "";
  private branch = "";
  private lastLoaded = new Date(0);
  private loading = true;
  private loadingEntries = false;

  get timeString() {
    return `${this.lastLoaded.toDateString()} ${(
      "0" + this.lastLoaded.getHours()
    ).slice(-2)}:${("0" + this.lastLoaded.getMinutes()).slice(-2)}:${(
      "0" + this.lastLoaded.getSeconds()
    ).slice(-2)}`;
  }

  private async mounted() {
    const gitLab = readGitLabInfo(this.$store);
    try {
      this.projectName = (
        await api.getProject(gitLab.projectId)
      ).name_with_namespace;
      this.branch = gitLab.branch;
      this.lastLoaded = readLastLoad(this.$store);
    } catch (e) {
      await dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Unable to load Project Name:<br>${e}`)
      );
    }
    this.loading = false;
  }

  private async startLoadEntries() {
    if (readHasUnsavedChanges(this.$store)) {
      if (!window.confirm("You have unsaved changes. Continue?")) {
        await dispatchRaiseErrorTimeout(
          this.$store,
          new Error("Loading has not been executed.")
        );
        return;
      }
    }
    this.loadingEntries = true;
    await dispatchLoadEntries(this.$store);
    this.lastLoaded = readLastLoad(this.$store);
    this.loadingEntries = false;
  }
}
